import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, getMatIconFailedToSanitizeUrlError, MatSnackBar } from '@angular/material'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ConsultationService, DialogService, VisiteService } from '../../../../../services'
import { ConfirmComponent } from '../confirm-dialog/confirm.component'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { forkJoin } from 'rxjs'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { isNumber } from 'lodash'

const KEY = 'confirm-dialog'

@Component({
  selector: 'consultation-shift',
  templateUrl: './consultation-shift.component.html',
  styleUrls: ['./consultation-shift.component.scss']
})
export class ConsultationShiftDialog extends BaseDialogComponent implements OnInit {
  consultations: any = [];
  dataSource : MatTableDataSource<any>;
  displayedColumns: string[] = ['select','consultation', 'date', 'newDate'];
  dayInterval: number = 0;
  monthInterval: number = 0;
  dateIntervalForm: FormGroup;
  loading : boolean = false;
  maxDays: number = 100;
  maxMonths: number = 18;
  dayOptions: number[] = Array.from({ length: this.maxDays+1 }, (_, i) => i);
  monthOptions: number[] = Array.from({ length: this.maxMonths+1 }, (_, i) => i);

  constructor(
    public dialogRef: MatDialogRef<ConsultationShiftDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    dialogService: DialogService,
    private _snackbar: MatSnackBar,
    private consultationService: ConsultationService,
    private fb: FormBuilder,
    changeDetectorRef: ChangeDetectorRef
  ) {
    super(dialogRef, dialogService, changeDetectorRef);
  }

  ngOnInit() {
    console.log("data",this.data)
    if(this.data != undefined && this.data){
      if(this.data.consultations != undefined && this.data.consultations){
        this.data.consultations.forEach(cons => {
          cons.selected = true;
          if(this.isConsultationUpcoming(cons)){
            this.consultations.push(cons);
          }
        });

        this.dataSource = new MatTableDataSource(this.consultations);
        this.changeDetectorRef.detectChanges();
      }
    }
    this.changeDetectorRef.detectChanges();
    console.log("Consultations init",this.consultations,this.consultations.length)
  }

getDateLibelle(date) {
    const dateObj = new Date(date);

    const jour = String(dateObj.getDate()).padStart(2, '0');
    const mois = String(dateObj.getMonth() + 1).padStart(2, '0');
    const annee = dateObj.getFullYear();

    return `${jour}/${mois}/${annee}`;
}

getDateOffsetLibelle(date){
  var dateLibelle = "";
  if(this.dayInterval>0 || this.monthInterval>0){
    const dateOffset = this.getDateOffset(date);
    dateLibelle = this.getDateLibelle(dateOffset);
  }

  return dateLibelle;
}

getDateOffset(date){
  const dateObj = new Date(date);
  dateObj.setMonth(dateObj.getMonth() + this.monthInterval);
  dateObj.setDate(dateObj.getDate() + this.dayInterval);
  // Décaler à lundi si c'est samedi ou dimanche
  const dayOfWeek = dateObj.getDay();
  if (dayOfWeek === 0) {
    dateObj.setDate(dateObj.getDate() + 1); 
  } else if (dayOfWeek === 6) { 
    dateObj.setDate(dateObj.getDate() + 2); 
  }
  return dateObj;
}

getHourLibelle(object){
    const dateDebut = new Date(object.date_debut);
    const dateFin = new Date(object.date_fin);

    const heureDebut = String(dateDebut.getHours()).padStart(2, '0');
    const minuteDebut = String(dateDebut.getMinutes()).padStart(2, '0');
    const heureFin = String(dateFin.getHours()).padStart(2, '0');
    const minuteFin = String(dateFin.getMinutes()).padStart(2, '0');

    return `De ${heureDebut}h${minuteDebut} à ${heureFin}h${minuteFin}`;
}

getIntervalDayMonth(date) {
  const dateObj = new Date(date);
  const dateOffset = this.getDateOffset(date);

  let months = (dateOffset.getFullYear() - dateObj.getFullYear()) * 12;
  months -= dateObj.getMonth();
  months += dateOffset.getMonth();

  let days = dateOffset.getDate() - dateObj.getDate();
  if (days < 0) {
    months -= 1;
    const previousMonth = new Date(dateOffset.getFullYear(), dateOffset.getMonth() - 1, 1);
    days += new Date(previousMonth.getFullYear(), previousMonth.getMonth() + 1, 0).getDate();
  }

  const intervalMonths = months>0? `P${months}M`: null;
  const intervalDays = days>0? `P${days}D`: null;

  return {
    month: intervalMonths,
    day : intervalDays
  };
}
isConsultationUpcoming(consult) {
  if (consult.date_debut !== undefined) {
    const dateDebut = new Date(consult.date_debut);
    const currentDate = new Date();
    if (dateDebut < currentDate) {
      return false; 
    } else {
      return true;
    }
  }
  return false;
}


onClickSave(){
  const consultationsToChange = []
  this.consultations.forEach(consult => {
    if(consult.selected){
      consult.shift = this.getIntervalDayMonth(consult.date_debut);
      consultationsToChange.push(consult);
    }
  });
  var libelle = "Êtes-vous sûr(e) de vouloir décaler " + consultationsToChange.length + " séance(s) de ";
  libelle += (this.dayInterval>0)? this.dayInterval + " jours" : "";
  libelle += (this.dayInterval>0 && this.monthInterval)? " et ": "";
  libelle += (this.monthInterval)? this.monthInterval + " mois" : "";
  libelle += " ?";
  const confDialogRef = this.dialogService.open(ConfirmComponent, {
    data : {
      libelle : libelle
    }
  });
  confDialogRef.afterClosed().subscribe(res => {
    if(res === "true"){
      this.loading = true;
      this.consultationService.setMultiConsultationDates(consultationsToChange).subscribe(res=>{
        if(res.result){
          this._snackbar.open("Décalages de séance(s) effectués", '', {
            duration: 2000,
          })
        }
        this.loading = false;
        this.dialogRef.close(res.result? res.result: false);
      })
    }
  })
}

}
